import { validateField } from '@rammetec/data-access';
/**
 * L0 pass — runs the data-access value-validation engine over a chosen set of
 * descriptor fields and returns a `fieldName → message` map (empty when all valid).
 *
 * Scope to the form-editable / write-relevant fields (`fields`) so generated /
 * non-form fields (e.g. a required `id`) are not validated as if the caller had
 * to supply them.
 */
export function runDescriptorValidation(descriptor, values, fields) {
    const record = values;
    const byName = new Map(descriptor.fields.map((f) => [f.name, f]));
    const errors = {};
    for (const name of fields) {
        const f = byName.get(name);
        if (!f)
            continue;
        const message = validateField(f, record[name]);
        if (message)
            errors[name] = message;
    }
    return errors;
}
//# sourceMappingURL=runDescriptorValidation.js.map